import { addMessage } from '@/store/messages'
import { receiveMessages } from '@/types/websocket/webchat'
import { MessageChat } from '@/types/message'
import { setAttendance, sumUnreadMessages } from '@/store'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import notification from '../../assets/sounds/notifications/cricks.mp3'

/**
 * Receive a message from the webchat and send it to the bot.
 * @param {object} input
 */
const receiveMessages = (input: receiveMessages) => {
  setAttendance(input.attendanceId)

  const webchatOpen = document.querySelectorAll('.webchat-open').length !== 0
  if (!webchatOpen) sumUnreadMessages()
  if (!webchatOpen || !document.hasFocus()) new Audio(notification)?.play()

  input.messages.forEach((message) => {
    const newMessage: MessageChat = {
      id: Math.ceil(Math.random() * 100000000),
      uuid: message.uuid,
      type: 'received',
      origin: message.origin,
      device: message.device,
      content: message.content,
      ack: 2,
      timestamp: message.timestamp,
      status: 'received'
    }

    addMessage(newMessage)
  })
}

export default { receiveMessages }
